import { render } from "./AdvisorCallToAction.vue?vue&type=template&id=19e49997&scoped=true"
import script from "./AdvisorCallToAction.vue?vue&type=script&lang=js"
export * from "./AdvisorCallToAction.vue?vue&type=script&lang=js"

import "./AdvisorCallToAction.vue?vue&type=style&index=0&id=19e49997&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-19e49997"

export default script